export const FOOTER_BLOCK_s4 = {
  "blockType": "FOOTER",
  "blockDesign": "FooterDesign1",
  "editFormName": "FOOTER_FORM_1",
  "styleProps": {
    "background-color": "#BFC8DB",
    "padding": "80px 20px 80px 20px",
    "background-image": "linear-gradient(to right,#7DE5BA,#B6FFFF)"
  },
  "logo": {
    "text": "Nuvdic",
    "href": "#",
    "styleProps": {
      "color": "#333333",
      "font-family-bk": "'Lato', sans-serif",
      "font-family": "'Lato', sans-serif",
      "font-size": "10rem",
      "line-height": "1",
      "padding": "0px 0px 0px 0px"
    },
    "stylePropsTab": {
      "font-size": "4.5rem",
      "line-height": "1"
    },
    "stylePropsMob": {
      "font-size": "3rem",
      "line-height": "1"
    }
  },
  "description": {
    "list": [],
    "styleProps": {
      "color": "#333333",
      "font-size": "1.25rem",
      "line-height": "1.75rem",
      "max-width": "384px",
      "margin": "0px 0px 120px 0px"
    }
  },
  "copy": {
    "text": "© Copyright 2022 FlexBee. All Rights Reserved.",
    "href": "#",
    "styleProps": {
      "color": "#333333",
      "margin": "0px 0px 0px 0px"
    }
  },
  "terms": {
    "text": "Terms",
    "href": "#",
    "styleProps": {
      "color": "#333333",
      "font-size": "1rem",
      "line-height": "1.5rem"
    }
  },
  "privacy": {
    "text": "Privacy",
    "href": "#",
    "styleProps": {
      "color": "#333333",
      "font-size": "1rem",
      "line-height": "1.5rem"
    }
  },
  "metaDataId": 1746357708202,
  "afterIndex": 25,
  "blockId": 1746357708202,
  "stylePropsTab": {
    "padding": "60px 20px 60px 20px"
  },
  "stylePropsMob": {
    "padding": "40px 20px 40px 20px"
  }
}